'use client'

import { useTranslations } from 'next-intl'
import { Search } from 'lucide-react'
import { ScreenshotZoom } from './ScreenshotZoom'

export function FeatureSearch() {
  const t = useTranslations('features.search')
  return (
    <div className="flex flex-col gap-[20px]">
      {/* Main feature row */}
      <div className="flex flex-wrap gap-[16px] items-start">
        {/* Phone screenshot (clickable) */}
        <ScreenshotZoom src="/images/feature-search.png" alt={t('imageAlt')} />

        {/* Content */}
        <div className="flex flex-col gap-[6px] flex-1 min-w-0 break-words hyphens-auto">
          {/* Icon */}
          <div className="w-[24px] h-[24px]">
            <Search size={24} strokeWidth={2} className="text-[#6B8E6B]" />
          </div>

          {/* Text */}
          <div className="flex flex-col gap-[4px] pt-[2px]">
            <p className="text-xl font-bold">{t('title')}</p>
            <p className="text-l">
              {t('desc')}
            </p>
          </div>

          {/* Zoom button */}
        </div>
      </div>
    </div>
  )
}
